import React from 'react';
import PropTypes from 'prop-types';
import LayoutDefault from '../../components/LayoutDefault';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import withMemo from '../../decorators/withMemo';
import Paragraph from '../../components/Paragraph';
var PageTemplate = function PageTemplate(_ref) {
  var headerProps = _ref.headerProps,
    footerProps = _ref.footerProps,
    paragraphProps = _ref.paragraphProps;
  return /*#__PURE__*/React.createElement(LayoutDefault, {
    theme: {
      maxWidth: 640
    },
    header: /*#__PURE__*/React.createElement(Header, headerProps),
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paragraph, {
      text: paragraphProps == null ? void 0 : paragraphProps.text
    })),
    footer: /*#__PURE__*/React.createElement(Footer, footerProps)
  });
};
PageTemplate.propTypes = {
  headerProps: PropTypes.shape(Header.propTypes),
  footerProps: PropTypes.shape(Footer.propTypes),
  paragraphProps: PropTypes.shape(Paragraph.propTypes)
};
PageTemplate.defaultProps = {
  headerProps: null,
  footerProps: null,
  paragraphProps: null
};
export default withMemo()(PageTemplate);